var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fireplace") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2.955 5.043a.162.162 0 0 0 .01-.007l-.01.007zM3 5.571v.858c0 .33.008.473.022.549.076.014.22.022.549.022h48.858c.33 0 .473-.008.549-.022.014-.076.022-.22.022-.549v-.858c0-.33-.008-.473-.022-.549-.076-.014-.22-.022-.549-.022H3.571c-.33 0-.473.008-.549.022-.014.076-.022.22-.022.549zM3.57 2h48.86c1.006 0 1.546.14 2.035.4.49.262.873.646 1.134 1.135.262.489.401 1.029.401 2.036v.858c0 1.007-.14 1.547-.4 2.036A2.726 2.726 0 0 1 54.464 9.6c-.489.262-1.029.401-2.036.401H3.571c-1.007 0-1.547-.14-2.036-.4A2.726 2.726 0 0 1 .4 8.464C.139 7.976 0 7.436 0 6.43v-.858c0-1.007.14-1.547.4-2.036A2.726 2.726 0 0 1 1.536 2.4C2.024 2.139 2.564 2 3.57 2zM1.5 54a1.5 1.5 0 0 1 0-3h53a1.5 1.5 0 0 1 0 3h-53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M5 10.5a1.5 1.5 0 0 1 3 0v41a1.5 1.5 0 0 1-3 0v-41zm43 0a1.5 1.5 0 0 1 3 0v41a1.5 1.5 0 0 1-3 0v-41zm-4 41a1.5 1.5 0 0 1-3 0V23.56c0-1.606-.298-2.159-1.9-3.36C36.174 18.006 33.431 17 28 17s-8.174 1.006-11.1 3.2c-1.602 1.201-1.9 1.754-1.9 3.36V51.5a1.5 1.5 0 0 1-3 0V23.56c0-2.587.768-4.011 3.1-5.76C18.522 15.233 21.886 14 28 14c6.114 0 9.478 1.233 12.9 3.8 2.332 1.749 3.1 3.173 3.1 5.76V51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M28 54c-8.283 0-11.951-7.984-6.66-14.45 2.848-3.482 4.575-6.923 5.208-10.324.231-1.245 1.806-1.66 2.622-.693 3.789 4.497 6.225 8.86 7.285 13.103C38.33 49.136 35.574 54 28 54zm-4.34-12.55C19.96 45.973 22.27 51 28 51c5.376 0 6.991-2.85 5.545-8.636-.765-3.06-2.376-6.259-4.844-9.593-1.008 2.916-2.692 5.809-5.04 8.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M28.5 53c-4.005 0-5.474-4.406-3.842-7.67a69.395 69.395 0 0 1 2.556-4.602 1.5 1.5 0 0 1 2.572 0 69.395 69.395 0 0 1 2.556 4.601C33.974 48.594 32.505 53 28.5 53zm-1.158-6.33c-.768 1.536-.17 3.33 1.158 3.33 1.328 0 1.926-1.794 1.158-3.33-.34-.68-.726-1.407-1.158-2.181a54.654 54.654 0 0 0-1.158 2.182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireplace);
export default __webpack_public_path__ + "static/media/fireplace.fe84992b62016566e11d1ab19b2aff9d.svg";
export { ForwardRef as ReactComponent };